import { DollarSign, ChefHat, Utensils } from 'lucide-react';

export const cuisineOptions = [
  'Italienisch',
  'Japanisch', 
  'Indisch',
  'Mexikanisch',
  'Chinesisch',
  'Deutsch',
  'Türkisch',
  'Fast Food',
  'Amerikanisch',
  'Steakhouse',
  'Koreanisch',
  'Hausmannskost',
  'Thai',
  'Französisch',
  'Afrikanisch',
  'Süd Amerikanisch'
];

export const priceRangeOptions = [
  { value: '?', label: 'Alle Preisklassen' },
  { value: '€', label: '€ Preiswert (bis zu 30€)' },
  { value: '€€', label: '€€ Moderat (30-60$)' },
  { value: '€€€', label: '€€€ Gehoben (60-100€)' },
  { value: '€€€€', label: '€€€€ Luxuriös (über 100€)' }
];

export const dietaryOptions = [
  'Ich esse alles',
  'Vegetarisch',
  'Vegan',
  'Gluten-Frei',
  'Halal',
  'Kosher',
  'Laktose-Frei',
  'Regional',
  'Saisonal',
  'Umweltfreundlich'
];

export const atmosphereOptions = [
  'Casual',
  'Gehoben',
  'Sport Bar',
  'Party',
  'Sozial',
  'Speakeasy',
  'Industrial',
  'Pub',
  'Tiki Bar',
  'Bier Garten',
  'Wein Bar',
  'Kneipe',
  'Rooftop',
  'Cocktail Lounge',
  'Retro'
];

export const musicOptions = [
  'Live Band',
  'DJ',
  'Jazz',
  'Rock',
  'Pop',
  'Indie',
  'Elektronisch',
  '80s & 90s',
  'Hip-Hop & R&B',
  'Country',
  'Reggae',
  'Volksmusik',
  'Klassisch',
  'Lo-Fi/Chill'
];

export const languageOptions = [
  'Englisch',
  'Deutsch',
  'Französisch',
  "Spanisch",
  'Italienisch',
  'Slowakisch',
  'Slowenisch',
  'Tschechisch',
  'Ungarisch',
  'Mandarin',
  'Arabisch',
  'Russisch'
];

export const interestOptions = [
  'Lokale Speisen',
  'Street Food',
  'Food Markets',
  'Koch Kurse',
  'Essens Fotografie',
  'Essen aus anderen Kulturen',
  'Food Tours',
  'Traditionelle Rezepte',
  'Historisches Essen',
  'Fusion Küchen'
];

export const overseasDietaryOptions = [
  'Vegetarisch',
  'Vegan',
  'Halal',
  'Kosher',
  'Gluten-Frei',
  'Laktose-Frei',
  'Meeresfrüchte',
  'Organisch',
  'Lokale Produkte',
  'Frisch vom Bauernhof'
];

export const filterSections = [
  {
    title: 'search.cuisine',
    icon: ChefHat,
    options: cuisineOptions
  },
  {
    title: 'search.priceRange',
    icon: DollarSign,
    options: priceRangeOptions
  },
  {
    title: 'common.dietaryOptions',
    icon: Utensils,
    options: dietaryOptions
  }
];